<template>
  <v-dialog
    v-model="dialogoPublicidades"
    width="600px"
    transition="dialog-top-transition"
    @click:outside="mostrarDialogoPublicidad(false)"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    :retain-focus="false"
    ><v-carousel
      height="100%"
      style="min-height: 175px !important"
      :show-arrows="false"
      hide-delimiter-background
      delimiter-icon="mdi-circle-medium"
      cycle
      light
    >
      <v-carousel-item
        v-for="(item, i) in publicidadesDialogo"
        :key="i"
        style="min-height: 175px !important"
      >
        <v-card
          height="100%"
          min-height="250px"
          :style="{
            'padding-bottom': publicidadesDialogo.length > 1 ? '50px' : '0px'
          }"
        >
          <v-toolbar color="primary" dark class="text-center" dense>
            <div class="titulo titulo-local text-center" style="width: 100%">
              {{ item.title }}
            </div>
            <v-btn
              @click="mostrarDialogoPublicidad(false)"
              icon
              fab
              absolute
              right
            >
              <v-icon>mdi-close-circle</v-icon>
            </v-btn>
          </v-toolbar>
          <v-img
            v-if="item.image"
            :src="imgSrc(item.image)"
            width="100%"
            min-height="0"
            contain
          ></v-img>
          <v-card-text v-if="item.description" style="font-size: 16px">
            <div class="ql-editor" v-html="item.description"></div>
          </v-card-text>
        </v-card>
      </v-carousel-item>
    </v-carousel>
  </v-dialog>
</template>
<script>
import { mapActions, mapState } from "vuex";
import auth from "@/services/auth";
import conv from "@/utility/conversores";

export default {
  data() {
    return {
      conv
    };
  },
  computed: {
    ...mapState(["dialogoPublicidades", "publicidadesDialogo"]),
    userLogged() {
      return auth.getUserLogged();
    }
  },
  methods: {
    ...mapActions(["mostrarDialogoPublicidad"]),
    imgSrc(image) {
      return "data:" + image.dataType + ";base64," + image.base64;
    }
  },
  mounted() {}
};
</script>

<style scoped>
.titulo-local {
  font-weight: 300;
  font-size: 25px;
  line-height: 25px;
}
</style>
